<template>
  <form-box :title="$t('message.Booking.myBooking')">
    <template slot="right">
      <el-button type="primary" :disabled="!!serveTip" @click="$emit('onAddBooking')">
        {{ $t("message.Booking.addBtn") }}
      </el-button>
    </template>

    <!-- 預約信息 列表 -->
    <div class="booking_info">

      <!-- 預約分類 -->
      <slot name="class"></slot>

      <div
        v-for="item in showAllBooking
          ? bookingDetailsList
          : bookingDetailsList.slice(0, 4)"
        :key="item.id"
      >
        <div class="booking_list">
          <div :class="['title_box', item.status]">
            <div class="status">
              <MyTag style="margin-right: 12px;" :type="['success', 'disable', 'warning'][['CONFIRMED', 'CANCELED', 'EXPIRED'].indexOf(item.status)]">
                {{ $t(`message.Booking.${item.status}`) }}
              </MyTag>
              {{ $t("message.Booking.bookingDate") }}{{
                bookingFormatDate(item.details[0] && item.details[0].applicationDate)
              }}
            </div>
            <div class="button_group">
              <el-button
                v-if="item.status === 'CONFIRMED' && item.mainPhone == form.mobile"
                :disabled="!!serveTip"
                type="primary"
                @click="$emit('doCancelBooking', item)"
                plain
              >
                {{ $t("message.Booking.cancelBtn") }}
              </el-button>
            </div>
          </div>

          <MyCell>
            <MyCellItem
              :label="$t('message.Booking.applicationDate')"
              :value="$formatDate(item.createdTime, 'dd/MM/yyyy HH:mm:ss')"
            ></MyCellItem>
            <MyCellItem
              :label="$t('message.Booking.bookingPhone')"
              :value="item.mainPhone"
            ></MyCellItem>
            <MyCellItem
              :label="$t('message.Booking.applicationNo')"
              :value="item.applicationNo"
            ></MyCellItem>
            <MyCellItem
              v-if="item.status === 'CANCELED'"
              :label="$t('message.Booking.cancelDate')"
              :value="$formatDate(item.details && item.details[0] && item.details[0].cancelTime, 'dd/MM/yyyy HH:mm:ss')"
            ></MyCellItem>
          </MyCell>
        </div>
      </div>
      <!-- 查看所有預約 -->
      <div
        v-if="!showAllBooking && bookingDetailsList.length > 4"
        class="view_allBooking"
      >
        <el-button type="text" @click="showAllBooking = true">
          <div>{{ $t("message.Booking.viewAllBtn") }}</div>
          <i class="el-icon-arrow-down"></i>
        </el-button>
      </div>
      <!-- 暫無數據 -->
      <div
        v-if="!bookingDetailsList || !bookingDetailsList.length"
        v-html="$t('message.Booking.notData')"
        class="booking_noData"
      ></div>
    </div>
  </form-box>
</template>
<script>
import FormBox from "./FormBox.vue";
import MyCell from "@/components/MyCell.vue";
import MyCellItem from "@/components/MyCellItem.vue";
import MyTag from "@/components/MyTag.vue";
import { getWeek } from "@/util/util";

export default {
  components: {
    FormBox,
    MyCell,
    MyCellItem,
    MyTag,
  },
  props: {
    bookingDetailsList: Array,
    serveTip: String,
  },
  data() {
    return {
      showAllBooking: false,
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
    },
  },
  methods: {
    bookingFormatDate(date) {
      if (!date) return "";
      return `${this.$formatDate(date, "dd/MM/yyyy")}（${getWeek(date)}）`;
    },
  },
};
</script>
<style lang="scss" scoped>
.booking_info {
  .booking_list {
    border-radius: 6px;
    border: 1px solid #d0d0d0;
    margin-top: 16px;
    .title_box {
      display: flex;
      flex-wrap: wrap;
      background: #13a07b;
      color: #fff;
      font-size: 18px;
      padding: 16px;
      justify-content: space-between;
      align-items: center;
      border-radius: 6px 6px 0 0;
      .status {
        flex: 1;
      }
      .button_group {
        text-align: right;
      }
    }
    .CANCELED {
      background: #f5f5f5;
      color: #323232;
    }
    .EXPIRED {
      background: #ffc107;
      color: #fff;
    }
  }
  .view_allBooking {
    margin: 16px;
    text-align: center;
    .el-button--text {
      font-size: 16px;
    }
  }
  .booking_noData {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin: 80px 0 50px;
  }
}
</style>
